/* @flow */

import CompanyMembership from 'models/companies/companyMembership';
import InvoicePaymentResult from 'models/invoices/seller/invoicePaymentResult';

export default class PaymentResult {
  isComplete: boolean;
  isCancelled: boolean;
  isDeclined: boolean;
  isFailed: boolean;
  membership: CompanyMembership;
  invoices: InvoicePaymentResult[];
}
